module.exports = __webpack_public_path__ + "img/remark_02.3b602900.svg";